const MlJson = [
    {
        "id": 1,
        "html_title": "intro",
        "bootstrap_head_desc": [
            {
"bootstrap_title_heading": "Introduction to AI & ML",
"bootstrap_title_desc": `Artificial Intelligence (AI) is the simulation of human intelligence in machines, enabling them to perform tasks such as problem-solving, decision-making, and learning from data.  
Machine Learning (ML) is a subset of AI that focuses on teaching computers to learn patterns from data and make predictions or decisions without being explicitly programmed.  
While AI is a broad field, ML specifically deals with algorithms that improve automatically through experience.  
**Key Differences:**  
-- **AI** is the broader concept that includes ML and Deep Learning.  
-- **ML** is a technique within AI that enables systems to learn from data.  
-- **Data Science** involves analyzing and interpreting complex data to extract useful insights.`
            },
            {
"bootstrap_title_heading": "Types of Machine Learning",
"bootstrap_title_desc": `Machine Learning is categorized into three main types:  
-- **Supervised Learning:** The model is trained using labeled data, meaning the input data is paired with the correct output. Example: Predicting house prices based on historical data.  
-- **Unsupervised Learning:** The model is trained on data without predefined labels, allowing it to find hidden patterns and structures. Example: Customer segmentation in marketing.  
-- **Reinforcement Learning:** The model learns by interacting with an environment and receiving rewards or penalties based on its actions. Example: Training AI to play video games or control robots.`
            },
            {
"bootstrap_title_heading": "Real-World Applications",
"bootstrap_title_desc": `Machine Learning is widely used across different industries:  
-- **AI in Healthcare:** Used for disease detection, personalized treatment, and medical image analysis.  
-- **AI in Finance:** Helps in fraud detection, credit scoring, and stock market predictions.  
-- **AI in E-commerce:** Enhances customer experience with product recommendations, chatbots, and demand forecasting.  
-- **AI in Autonomous Systems:** Self-driving cars, smart assistants (Siri, Alexa), and automated robots.  
-- **How Companies Use AI:** Google (Search & Ads), Tesla (Self-Driving Cars), Amazon (Personalized Shopping), Netflix (Movie Recommendations).`
            },
            {
"bootstrap_title_heading": "Discussion & Q&A",
"bootstrap_title_desc": `This session will help students understand why they want to learn AI/ML and what their career goals are in this field.  
-- **Why do you want to learn AI/ML?** Exploring personal motivation and interest in AI.  
-- **What are your career goals in AI/ML?** Understanding the different career paths such as Data Science, AI Engineering, and Research.  
-- **Open Discussion:** Students can ask questions, share their thoughts, and explore future AI trends.`
            }
        ],
        "coursename": "Intro (Day 1)"
    },


    {
        "id": 2,
        "html_title": "python_basics",
        "bootstrap_head_desc": [
            {
"bootstrap_title_heading": "Introduction to Python for AI & ML",
"bootstrap_title_desc": `Python is the most popular programming language for AI & ML due to its simplicity, fast libraries, and strong community support.  
-- **Why Python for AI/ML?**  
---- Easy to learn with a readable syntax.  
---- Extensive libraries like NumPy, Pandas, TensorFlow, and Scikit-learn.  
---- Large community support and industry adoption.  
-- **Installing Python & Setting Up the Environment**  
---- Download and install Python from the official site (python.org).  
---- Install Jupyter Notebook and IDEs like PyCharm or VS Code for coding.  
---- Introduction to package management using **pip**.

learn from this link:https://v-extechsolution.in/learning/python/intro


`
            },
          
        ],
        "coursename": "Python (Day 2)"
    }
    
    

]

export default MlJson;